import React from 'react';
import { useTranslation } from 'react-i18next';
import { Check, X } from 'lucide-react';
import { FeedbackStep } from '../../../hooks/useSessionDetail';
import NeedHelpSection from './NeedHelpSection';

interface TeachingStepCardProps {
  step: FeedbackStep;
}

const TeachingStepCard: React.FC<TeachingStepCardProps> = ({ step }) => {
  const { t } = useTranslation();
  return (
    <div className={`teaching-step-card ${step.included ? 'included' : 'missed'}`}>
      <div className="step-card-header">
        <span className="step-number">{step.number}</span>
        <span className="step-name">{step.name}</span>
        <span className={`step-tag ${step.included ? 'included-tag' : 'missed-tag'}`}>
          {step.included ? <><Check size={12} /> {t('feedback.included')}</> : <><X size={12} /> {t('feedback.missed')}</>}
        </span>
      </div>
      {step.feedback && (
        <p className="step-feedback">{step.feedback}</p>
      )}
      {/* A missed step's feedback is often only "You missed this step.", so show what
          the step actually asks for. Included steps already quote the teacher doing it. */}
      {!step.included && step.description && (
        <p className="step-description">
          <span className="step-description__label">{t('feedback.whatStepLooksLike')}</span>
          {step.description}
        </p>
      )}
      {step.trainingContent && step.trainingContent.length > 0 && (
        <NeedHelpSection items={step.trainingContent} />
      )}
    </div>
  );
};

export default TeachingStepCard;
